
/**
 * Examples
  constructor(
    private httpClient: HttpClient
  ) {
    super(environment.API_BASE);
  }
  - For get request
    getCRPS(id: number): Observable<CRPResponse> {
      return this.httpClient.get<CRPResponse>(this.buildUrl(`/api/customers/${id}/crps/`));
    }
    search(queries: any) {
      return this.httpClient.get(this.buildUrl('/api/periodic_search/', queries));
    }
  - For post/patch/put request
    search(queries: any) {
      return this.httpClient.get(this.buildUrl('/api/periodic_search/'), queries));
    }
 */
export abstract class ApiAbstractService {

  protected constructor(
    private urlBase: string
  ) { }

  private buildQuery(queries: { [ key: string ]: any }): string {
    if (!queries || (Object.entries(queries).length === 0)) {
      return '';
    }

    return '?' + Object.keys(queries).map(key => `${key}=${encodeURI(queries[key])}`).join('&');
  }

  protected buildUrl(path: string, queries?: { [ key: string ]: any }) {
    if (!path.startsWith('/')) {
      path = '/' + path;
    }
    if (!path.endsWith('/')) {
      path = path + '/';
    }
    return `${this.urlBase}${path}${this.buildQuery(queries)}`;
  }
}
